import React from "react";

import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const store = useAppSelector(selectStore);

    return (
        <>
            Assess the mix of chains and independents and the spread of store types, from budget to premium near your {store?.name} store.
            Use this to check how well your store fits its surroundings and whether nearby mix could be influencing financial performance.
        </>
    );
};

export default Subtitle;
